import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
interface NoBSPromiseSlideProps {
  content: {
    headline: string;
    bullets: string[];
  };
}
export function NoBSPromiseSlide({
  content
}: NoBSPromiseSlideProps) {
  return <div className="bg-[#F5F5F5] rounded-2xl p-16 min-h-[600px] flex flex-col justify-center" data-id="element-188">
      <motion.h2 initial={{
      opacity: 0,
      x: -20
    }} animate={{
      opacity: 1,
      x: 0
    }} className="text-5xl font-bold text-[#1C1C1C] mb-12 border-l-8 border-[#0FB07D] pl-6" data-id="element-189">
        {content.headline}
      </motion.h2>

      <div className="space-y-8 max-w-4xl" data-id="element-190">
        {content.bullets.map((bullet, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2 + index * 0.1
      }} className="flex items-start gap-6 bg-white p-6 rounded-xl shadow-sm border border-[#4D4D4D]/10" data-id="element-191">
            <CheckCircle2 className="text-[#0FB07D] w-8 h-8 flex-shrink-0 mt-1" data-id="element-192" />
            <p className="text-2xl text-[#1C1C1C] font-medium leading-relaxed" data-id="element-193">
              {bullet}
            </p>
          </motion.div>)}
      </div>
    </div>;
}
export default NoBSPromiseSlide;